import { render, staticRenderFns } from "./Avatar.vue?vue&type=template&id=4644e6e8&lang=pug&"
import script from "./Avatar.vue?vue&type=script&lang=ts&"
export * from "./Avatar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\as3-portals\\AS3.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4644e6e8')) {
      api.createRecord('4644e6e8', component.options)
    } else {
      api.reload('4644e6e8', component.options)
    }
    module.hot.accept("./Avatar.vue?vue&type=template&id=4644e6e8&lang=pug&", function () {
      api.rerender('4644e6e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components/Avatar.vue"
export default component.exports